var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"rounded":"","small":"","text":"","color":"secondary","icon":_vm.isMobile()},on:{"click":function($event){return _vm.imprimirXml()}}},[_c('v-icon',{attrs:{"left":!_vm.isMobile()}},[_vm._v("mdi-xml")]),_vm._v(" "),(!_vm.isMobile())?_c('span',[_vm._v("XML")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }